import React, { memo, useState } from "react"
import { PracticeBarProps } from "./types"
import { StyledPracticeLogoImage } from "./style"

const PracticeLogo: React.FC<PracticeBarProps> = ({ practice }) => {
  const [visible, setVisible] = useState<Boolean>(true)
  const handleImageError = () => {
    setVisible(!visible)
  }
  return visible && practice.logo ? <StyledPracticeLogoImage url={practice.logo} alt="Practice logo" onError={handleImageError} /> : null
}

export default memo(PracticeLogo)
